import { blogArticles } from '../data/blogArticles';

export const slugify = (text = '') => {
  let t = text.toLowerCase();
  const map = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss' };
  t = t.replace(/[äöüß]/g, (c) => map[c] || c);
  return t.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
};

const slugById = Object.fromEntries(blogArticles.map((a) => [a.id, a.slug]));

export const getSlug = (article) => {
  if (!article) return '';
  return slugById[article.id] || article.slug || slugify(article.title || '');
};
